const breakpoints = {
    xm: '320px',
    sm: '620px',
    md: '900px',
    lg: '1200px',
    xl: '1600px',
    uw: '2060px'   
};

export default breakpoints;